export default function GridPlotVisualMap(
   heatSeriesIndices,
   seriesConfigs,
   plotConfigs,
) {
   return heatSeriesIndices.map((h, i) => {
      let min = -Infinity;
      let max = Infinity;
      h.forEach((s) => {
         seriesConfigs[s].data.forEach((d) => {
            if (d[2] > min) {
               min = d[2];
            }
            if (d[2] < max) {
               max = d[2];
            }
         });
      });

      return {
         type: "continuous",
         min: plotConfigs[i].series[0].min ? plotConfigs[i].series[0].min : min,
         max: plotConfigs[i].series[0].max ? plotConfigs[i].series[0].max : max,
         seriesIndex: h,
         show: false,
         inRange: {
            color: [
               "#005D63",
               "#008996",
               "#00C08B",
               "#FFD100",
               "#FF6B00",
               "#E04403",
            ],
         },
      };
   });
}
